import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '65px',
    marginBottom: '20px'
  },
  filters: {
    height: '32px',
    marginBottom: '20px',
    marginRight: '5px'
  },
  box: {
    height: '600px'
  },
  paragraph: {
    main: {
      marginTop: '1rem'
    },
    text: {
      height: '32px'
    }
  }
};

const SkeletonLowestRatesProperties = (props) => {
  const [className, style] = useStyles(props);
  const { header, filters, box, paragraph } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="SkeletonLowestRatesProperties"
    >
      <Row gutters>
        <Col xs="4">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs="6">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
        <Col xs="6">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
      </Row>
      <Row gutters={false}>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
        <Col xs="1">
          <Box className="fr-skeleton-element" style={filters} />
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-element" style={box} />
        </Col>
      </Row>
      <Row gutters>
        <Col xs={6} style={paragraph.main}>
          <Box className="fr-skeleton-box" style={paragraph.text} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonLowestRatesProperties.componentName = 'SkeletonLowestRatesProperties';

export default SkeletonLowestRatesProperties;
